import { SmartActionAiMessage } from '@bitte-ai/types';
import { useEffect, useState } from 'react';
import { getAgentIdFromMessage } from '../../../lib/chat';
import { DEFAULT_AGENT_ID } from '../../../lib/constants';
import { BITTE_BLACK_IMG } from '../../../lib/images';

export const useMessageAgentId = (
  messages: SmartActionAiMessage[],
  agentImage?: string,
  agentName?: string,
) => {
  const [messagesWithAgentId, setMessagesWithAgentId] = useState<
    SmartActionAiMessage[]
  >([]);

  const updateAgentIdForMessages = (
    incomingMessages: SmartActionAiMessage[],
  ) => {
    return incomingMessages.map((message) => {
      let agentId = message.agentId || getAgentIdFromMessage(message);
      if (!agentId) {
        agentId = DEFAULT_AGENT_ID;
      }

      const existingMessage = messagesWithAgentId?.find(
        (m) => m.id === message.id,
      );
      const messageAgentImage =
        existingMessage?.agentImage || agentImage || BITTE_BLACK_IMG;
      return {
        ...message,
        agentId,
        agentImage: messageAgentImage,
        agentName,
      };
    });
  };

  useEffect(() => {
    const updatedMessages = updateAgentIdForMessages(messages);
    setMessagesWithAgentId(updatedMessages);
  }, [messages]);

  return messagesWithAgentId;
};
